// Write your JS code here
import {Component} from 'react'

import Loader from 'react-loader-spinner'

import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'

import './index.css'

class BlogItemDetails extends Component {
  state = {blogItemDetails: {}, isLoading: true}

  componentDidMount() {
    this.getSpecificBlogItemDetails()
  }

  getSpecificBlogItemDetails = async () => {
    const {match} = this.props
    const {params} = match
    const {id} = params
    const response = await fetch(`https://apis.ccbp.in/blogs/${id}`)
    const data = await response.json()
    const formatedData = {
      id: data.id,
      title: data.title,
      imageUrl: data.image_url,
      avatarUrl: data.avatar_url,
      author: data.author,
      content: data.content,
      topic: data.topic,
    }
    this.setState({blogItemDetails: formatedData, isLoading: false})
  }

  render() {
    const {blogItemDetails, isLoading} = this.state
    const {title, imageUrl, avatarUrl, author, content, topic} = blogItemDetails
    return (
      <div className="Specific-blogItem-details">
        {isLoading ? (
          <div data-testid="loader">
            <Loader type="TailSpin" color="#00bfff" height={50} width={50} />
          </div>
        ) : (
          <div className="blog-item-details-container">
            <h1 className="blog-title">{title}</h1>
            <div className="profile">
              <img src={avatarUrl} className="avatar" alt={author} />
              <p className="author-name">{author}</p>
            </div>
            <img src={imageUrl} className="topic-image" alt={title} />
            <p className="content">{content}</p>
          </div>
        )}
      </div>
    )
  }
}
export default BlogItemDetails
